import React from "react";
import './logo.css';

const Logo = () =>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 229.2 27.38" style={{ color: "red" }}>
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <polygon className="cls-1" points="11.72 0.64 0 26.79 6.27 26.79 7.42 24.07 8.18 22.3 10.38 17.15 11.66 14.13 14.89 6.54 17.74 13.28 17.94 13.75 21.59 22.3 22.45 24.33 23.48 26.79 29.8 26.79 18.07 0.64 11.72 0.64" />
                <polygon className="cls-1" points="217.46 0.64 211.12 0.64 199.4 26.79 205.67 26.79 206.82 24.07 207.58 22.3 209.77 17.15 211.05 14.13 214.29 6.54 217.14 13.28 217.34 13.75 220.98 22.3 221.85 24.33 222.88 26.79 229.19 26.79 217.46 0.64" />
                <polygon className="cls-1" points="53.32 0.64 47.49 0.64 47.49 26.78 66.39 26.78 66.39 21.44 53.32 21.44 53.32 0.64" />
                <path className="cls-1" d="M79.34,5.83h8v21h5.79v-21h8V.64H79.34Z" />
                <polygon className="cls-1" points="170.94 0.64 165.12 0.64 165.12 26.78 184.01 26.78 184.01 21.44 170.94 21.44 170.94 0.64" />
                <path className="cls-1" d="M131.74,0a13.69,13.69,0,1,0,13.68,13.69A13.69,13.69,0,0,0,131.74,0Zm0,22.15a8.46,8.46,0,1,1,8.46-8.46A8.45,8.45,0,0,1,131.74,22.15Z" /></g>
        </g>
    </svg>;

export default Logo;


// WEBPACK FOOTER //
// ./src/components/Logo.js